module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solicitud-vacaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.isEditing) ? _c('span', {
    staticClass: "little"
  }, [_vm._v("Modificando la solicitud " + _vm._s(_vm.solicitud.id))]) : (_vm.isExcepcion) ? _c('span', {
    staticClass: "little"
  }, [_vm._v("Ingresa una solicitud de vacaciones sin validaciones")]) : _c('span', [_vm._v("Ingresa una solicitud de vacaciones")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition-group', {
    staticClass: "contenedor-datos",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, [(_vm.mostrarIndicaciones) ? _c('div', {
    key: "indicaciones",
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        _vm.mostrarIndicaciones = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La solicitud la debe aprobar ")]), _c('strong', [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('span', [_vm._v(_vm._s(_vm.jefe))])])])])]) : _vm._e(), (_vm.empleadoExcepcion && _vm.empleadoExcepcion.codigo) ? _c('div', {
    key: "indicaciones-excepcion",
    staticClass: "indicaciones"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Datos a tener en cuenta")])]), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Ingresando una excepción para ")]), _c('strong', [_vm._v(_vm._s(_vm.empleadoExcepcion.nombre))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La solicitud la debe aprobar ")]), _c('strong', [_vm._v(_vm._s(_vm.empleadoExcepcion.nombreJefe))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por tomar ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.empleadoExcepcion.diasReales))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Días por programar ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.empleadoExcepcion.diasDisponibles))])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("La fecha de retorno debe ser ")]), _c('strong', [_vm._v("después a hoy")]), _c('span', [_vm._v(", si no fuera el caso, por favor comunicarse con sistemas")])]), _c('li', {
    staticClass: "list-item"
  }, [_c('span', [_vm._v("Le llegará un mail de notificación a " + _vm._s(_vm.empleadoExcepcion.nombre) + " para que ")]), _c('strong', [_vm._v("envíe ")]), _c('span', [_vm._v("la solicitud a su jefe")])])])]) : _vm._e(), _c('div', {
    key: "transaccion",
    staticClass: "contenedor-transaccion"
  }, [(_vm.isExcepcion) ? _c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoEmpleado),
      expression: "codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigoEmpleado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _c('div', {
    staticClass: "fechas"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desde),
      expression: "desde"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
    },
    domProps: {
      "value": (_vm.desde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desde = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasta),
      expression: "hasta"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
    },
    domProps: {
      "value": (_vm.hasta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hasta = $event.target.value
      }
    }
  })])]), _c('p', [_c('span', [_vm._v("Retornarias el ")]), _c('strong', [_vm._v(_vm._s(_vm.retorno))])]), _c('p', [_c('span', [_vm._v("Te tomarias ")]), _c('strong', [_vm._v(_vm._s(_vm.dias))]), _c('span', [_vm._v(" dias de vacaciones")])]), _c('div', {
    staticClass: "acciones"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.guardar(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _c('span', [_vm._v("Guardar")])]), (!_vm.isExcepcion) ? _c('button', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.guardar(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _c('span', [_vm._v("Guardar y Enviar")])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7e57344","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Solicitud_Vacaciones.vue
// module id = 967
// module chunks = 0